import React from 'react'
import { Row, Col, Card, CardBody, CardTitle, CardText, Button } from 'reactstrap'
import PageWrap from 'components/PageWrap'

const ResourcesPage = () => (
  <PageWrap title="Resources">
    <Row className="g-4">
      {["Mining & Metals", "Environmental", "Food & Agriculture"].map((n, i) => (
        <Col md="6" lg="4" key={n}>
          <Card className="h-100 border-0 shadow-sm">
            <CardBody>
              <CardTitle tag="h5">{n}</CardTitle>
              <CardText className="text-muted">Short description for {n}. Add PDFs, case studies, and methods.</CardText>
              <Button color="primary" className="rounded-pill">Open</Button>
            </CardBody>
          </Card>
        </Col>
      ))}
    </Row>
  </PageWrap>
)

export default ResourcesPage